module.exports = require("accounting");


//////////////////
// WEBPACK FOOTER
// external "accounting"
// module id = 21
// module chunks = 0